import React from 'react';
import ReactDOM from 'react-dom/client';
import { Buffer } from 'buffer';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './landing/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './styles/tokens.css';
import './styles/global-welland.css';
import './styles/index.css';
import { appRouter } from './app/router';
import { GOOGLE_CLIENT_ID } from './landing/config/constants';

/** Шум в devtools: шрифты (pdf/canvas), Chrome [Violation], без влияния на работу приложения. */
function suppressConsoleNoise(firstArg) {
  if (typeof firstArg !== 'string') return false;
  if (/unsupported (GPOS|GSUB) table/i.test(firstArg)) return true;
  if (/^\[Violation\]/i.test(firstArg)) return true;
  return false;
}

const originalWarn = console.warn.bind(console);
console.warn = (...args) => {
  if (suppressConsoleNoise(args[0])) return;
  originalWarn(...args);
};

const originalLog = console.log.bind(console);
console.log = (...args) => {
  if (suppressConsoleNoise(args[0])) return;
  originalLog(...args);
};

const originalInfo = console.info.bind(console);
console.info = (...args) => {
  if (suppressConsoleNoise(args[0])) return;
  originalInfo(...args);
};

const originalDebug = console.debug.bind(console);
console.debug = (...args) => {
  if (suppressConsoleNoise(args[0])) return;
  originalDebug(...args);
};

const originalError = console.error.bind(console);
console.error = (...args) => {
  if (typeof args[0] === 'string' && /unsupported (GPOS|GSUB) table/i.test(args[0])) return;
  originalError(...args);
};

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

/* Лендинг: не восстанавливать позицию скролла при F5/первом входе (до монтирования React). */
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  try {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  } catch {
    /* ignore */
  }
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const Inner = (
  <AuthProvider>
    <ThemeProvider>
      <RouterProvider router={appRouter} />
    </ThemeProvider>
  </AuthProvider>
);

const appTree = (
  <HelmetProvider>
    {GOOGLE_CLIENT_ID
      ? <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>{Inner}</GoogleOAuthProvider>
      : Inner
    }
  </HelmetProvider>
);

// В dev отключаем StrictMode, чтобы не было двойного монтирования WebGL Canvas.
if (process.env.NODE_ENV === 'production') {
  root.render(<React.StrictMode>{appTree}</React.StrictMode>);
} else {
  root.render(appTree);
}
